import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Breadcrumb, Col, Collapse, Row, Space, Table } from "antd";

import {
    ArrowRight,
    Bank,
    ChevronRight,
    Clock,
    Document,
    MoneyBagCoin,
    User,
} from "assets/icons";

import Spacer from "components/Spacer";
import Container from "components/Container";
import { useSingle } from "modules/serviceRegister/hooks";

import cls from "./ServiceView.module.scss";
import MetaDataCard from "pages/ServiceRegisterList/components/MetaDataCard";

import { Link } from "react-router-dom";
import config from "config";
const LEX_TYPES = {
    QAROR: 3972,
    FARMON: 3973,
    QONUN: 3968,
    KODEKS: 3964,
    KONSTITUTSIYA: 4131,
    FARMOYISH: 588,
    BUYRUQ: 486,
};
//
// const formatDocument = (
//   value,
//   language,
//   t,
// ) => {
//     const {
//               docName,
//               displayNameForm,
//               basisDate,
//               docNumber,
//               lexId,
//           } = value;
//
//     if (
//       lexId === LEX_TYPES.KODEKS
//       || lexId === LEX_TYPES.KONSTITUTSIYA
//     ) {
//         return <div>{docName}</div>;
//     }
//
//     let description = '';
//
//     if (lexId === LEX_TYPES.BUYRUQ) {
//         const parts = [];
//
//         if (basisDate) {
//             parts.push(
//               language === 'uz'
//               ? `${basisDate} ${t('registered_at')}`
//               : `${t('registered_at')} ${basisDate}`,
//             );
//         }
//
//         if (docNumber) {
//             parts.push(`${t('register_number')} ${docNumber}`);
//         }
//
//         description = parts.join(', ');
//     } else {
//         const parts = [];
//
//         if (language === 'en') {
//             if (basisDate) {
//                 parts.push(`${t('year')} ${basisDate}`);
//             }
//
//             if (docNumber) {
//                 parts.push(`${docNumber}${t('number')}`);
//             }
//
//             description = parts.join(', ');
//         } else if (language === 'ru') {
//             if (basisDate) {
//                 parts.push(`${basisDate} ${t('year')}`);
//             }
//
//             if (docNumber) {
//                 parts.push(`${docNumber}${t('number')}`);
//             }
//
//             description = parts.join(', ');
//         } else {
//             if (basisDate) {
//                 parts.push(`${basisDate} ${t('at')}`);
//             }
//
//             if (docNumber) {
//                 parts.push(`${docNumber}${t('number')}`);
//             }
//
//             description = parts.join(' ');
//         }
//     }
//
//     const secondLine = [
//         displayNameForm,
//         description,
//     ]
//       .filter(Boolean)
//       .join(', ');
//
//     return (
//       <>
//           <div>{docName}</div>
//           {secondLine && <div>{secondLine}</div>}
//       </>
//     );
// };

const formatDocument = (
  value,
  language,
  t,
) => {
    const {
              docName,
              displayNameForm,
              basisDate,
              docNumber,
      number,
              lexId,
          } = value;

    if (
      lexId === LEX_TYPES.KODEKS ||
      lexId === LEX_TYPES.KONSTITUTSIYA
    ) {
        return <div>{docName}</div>;
    }

    let description = '';

    if (lexId === LEX_TYPES.BUYRUQ) {
        const parts = [];

        if (basisDate) {
            parts.push(
              language === 'uz'
              ? `${basisDate} ${t('registered_at')}`
              : `${t('registered_at')} ${basisDate}`,
            );
        }

        if (docNumber) {
            parts.push(`${t('register_number')} ${docNumber}`);
        }

        description = parts.join(', ');
    } else {
        const parts = [];

        if (language === 'en') {
            if (basisDate) {
                parts.push(`${t('year')} ${basisDate}`);
            }

            if (docNumber) {
                parts.push(`${docNumber}${t('number')}`);
            }

            description = parts.join(', ');
        } else if (language === 'ru') {
            if (basisDate) {
                parts.push(`${basisDate} ${t('year')}`);
            }

            if (docNumber) {
                parts.push(`${docNumber}${t('number')}`);
            }

            description = parts.join(', ');
        } else {
            if (basisDate) {
                parts.push(`${basisDate} ${t('at')}`);
            }

            if (docNumber) {
                parts.push(`${docNumber}${t('number')}`);
            }

            description = parts.join(' ');
        }
    }

    return (
      <>
          <div>{docName}</div>

          {(displayNameForm || description) && (
            <div>
                {displayNameForm && (
                  <>
                      <a
                        href={`https://lex.uz/docs/${number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                          {displayNameForm}
                      </a>
                      {description && ', '}
                  </>
                )}

                {description}
            </div>
          )}
      </>
    );
};

const ServiceView = () => {
    const { t, i18n } = useTranslation();
    const { id } = useParams();

    const { item, isFetched } = useSingle({ id });

    const docNames = [
        ...new Map(
          (item?.lexDataRequirements ?? []).map(item => [item.docName, item])
        ).values()
    ];

    const items = [
        {
            key: "1",
            label: t("service_approval_authorities"),
            children: item.hasPrinciples && item?.organizations.length > 0 ? <ul>{item?.organizations?.map(value => <li key={value?.id}>{value.name[i18n.language]}</li>)}</ul> : <p className={cls.slash}>—</p>,
        },
        {
            key: "2",
            label: t("service_regulatory_documents"),
            children: docNames.length > 0 ? <ul>{docNames?.map(value => <li key={value.id}>{formatDocument(value, i18n.language, t)}</li>)}</ul> : <p className={cls.slash}>—</p>,
        },
        {
            key: "3",
            label: t("service_delivery_point"),
            children: item?.servicePoints.length > 0 ? <>
                <ul style={{ listStyleType: 'none' }}>{item?.servicePoints.map(is => <li>
                    {is?.file?.uuid && <img src={`${config.api.img_url}/${is?.file?.uuid}`} alt="logo" />}
                    <a href={`${is.link.startsWith("https") ? is.link : `https://${is.link}`}`}
                        target="_blank">
                        {is.name}
                    </a>
                </li>)}
                </ul>
            </> : <p className={cls.slash}>—</p>,
        },
        {
            key: "4",
            label: t("service_required_documents"),
            children: item?.documents.length > 0 ? <ol>{item?.documents?.map(value => <li>{value}</li>)}</ol> : <p className={cls.slash}>—</p>,
        },
        item?.paymentType!=='FREE' && {
            key: "5",
            label: t("service_payment_details"),
            children:
              <div className={cls.table}>
                {
                  item?.payments?.length > 0 ?
                  <table className={cls.tableWrapper}>
                    <thead>
                    <tr>
                      <th className={cls.tableHead}>{t(`field_payments_type`)}</th>
                      <th className={cls.tableHead}>{t(`field_payments_percent`)}</th>
                      <th className={cls.tableHead}>{t(`field_payments_accelerated`)}</th>
                      <th className={cls.tableHead}>{t(`field_payments_description`)}</th>
                    </tr>
                    </thead>
                    <tbody className={cls.tableBody}>
                    {
                      item.payments.map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <tr className={cls.tableRow} key={index}>
                          <td className={cls.tableInfo}>
                                {t(item.type)}
                          </td>
                          <td className={cls.tableInfo}>
                                {item.percent}
                          </td>
                          <td className={cls.tableInfo}>{item.accelerated ? t('YES') : t('NO')}</td>
                          <td className={cls.tableInfo}>{item.description}</td>
                        </tr>
                      ))}
                    </tbody>
                </table> : <p className={cls.slash}>—</p>
              }
            </div>,
        },
        item?.expire?.length > 0 && {
            key: "6",
            label: t("application_review_period"),
            children:
              <div className={cls.table}>
                    {item?.expire?.length > 0 ?
                      <table className={cls.tableWrapper}>
                        <thead>
                        <tr>
                          <th className={cls.tableHead}>{t(`field_expire_type`)}</th>
                          <th className={cls.tableHead}>{t(`field_expire_value`)}</th>
                          <th className={cls.tableHead}>{t(`field_expire_accelerated`)}</th>
                          <th className={cls.tableHead}>{t(`field_expire_description`)}</th>
                        </tr>
                        </thead>
                        <tbody className={cls.tableBody}>
                        {item.expire.map((item, index) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <tr className={cls.tableRow} key={index}>
                            <td className={cls.tableInfo}>
                              {t(item.type)}
                            </td>
                            <td className={cls.tableInfo}>
                              {item.value}
                            </td>
                            <td className={cls.tableInfo}>
                              {item.accelerated ? t('YES') : t('NO')}
                            </td>
                            <td className={cls.tableInfo}>{item.description}</td>
                          </tr>
                        ))}
                        </tbody>
                      </table> : <p className={cls.slash}>—</p>
                    }
              </div>
        },
        {
            key: "7",
            label: t("service_requirements"),
            children:
              item.lexDataRequirements.length > 0 ?
              item.lexDataRequirements.length === 1 ?
              <div style={{ paddingLeft: 30 }}>
                  {
                      item.lexDataRequirements.map(value =>
                        <p key={value.id} style={{ marginBottom: 5 }}>
                            <a href={value?.link}>
                                {value?.content?.uz}
                            </a>
                        </p>
                      )
                  }
              </div> :
              <ol>
                {
                  item.lexDataRequirements.map(value =>
                    <li key={value.id} style={{ marginBottom: 5 }}>
                      <a href={value?.link}>
                        {value?.content?.uz}
                      </a>
                    </li>
                  )
                }
              </ol> :
              <p className={cls.slash}>—</p>,
        },
        {
            key: "8",
            label: t("service_life_situations"),
            children: item?.lifeSituations.length > 0 ? <ul>{item?.lifeSituations?.map(ls => <li key={ls.id}>
                <h4>{ls.name[i18n.language]}</h4>
                <p>{ls.description[i18n.language]}</p>
            </li>)}</ul> : <p className={cls.slash}>—</p>,
        },
        {
            key: "9",
            label: t("service_comment"),
            children: item?.description ? item.description : <p className={cls.slash}>—</p>
        },
    ].filter(Boolean);

    return (
        <Container>
            <Spacer size={35} />

            <Breadcrumb separator=">">
                <Breadcrumb.Item href="/">{t("home")}</Breadcrumb.Item>
                <Breadcrumb.Item href="/service-register">{t("service_register")}</Breadcrumb.Item>
                <Breadcrumb.Item href="/service-register/list">{t("service_register_list")}</Breadcrumb.Item>
                <Breadcrumb.Item>{t('service')} - {item.uniqueNumber}</Breadcrumb.Item>
            </Breadcrumb>

            <Spacer size={32} />

            <div className={cls.content}>
                <div className={cls.flex}>
                    <div className={cls.left}>
                        <strong className={cls.largeTitle}>
                            {item.serviceName ? item.serviceName[i18n.language] : ''}
                        </strong>

                        {item?.addition?.length > 0 && (
                            <div className={cls.additionBlock}>
                                <span className={cls.additionTitle}>
                                    {t("service_subtype_name")}
                                </span>

                                <div className={cls.additionList}>
                                    {item.addition.map((value, index) => (
                                        <div key={index} className={cls.additionItem}>
                                            <span className={cls.arrow}>↳</span>
                                            <span className={cls.additionText}>
                                                {value[i18n.language]}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className={cls.right}>
                        <span className={cls.title}>{t("chapter_number")}</span>
                        <strong className={cls.largeTitle}>{item.uniqueNumber}</strong>
                    </div>
                </div>
            </div>

            <div className={cls.center}>
                <Row gutter={[8, 8]} align={'stretch'}>
                    {/*<Col xs={24} sm={12} lg={6}>*/}
                    {/*    <MetaDataCard*/}
                    {/*        icon={<Clock />}*/}
                    {/*        title={t("application_review_period")}*/}
                    {/*        text={item?.expire.length > 0 && (*/}
                    {/*            <ul>*/}
                    {/*                {item.expire.map(value => <li key={value.id}>{`${value.value ? value.value : ""} ${t(value.type)} ${value.accelerated ? `- ${t("field_payments_accelerated")}` : ""}`}</li>)}*/}
                    {/*            </ul>*/}
                    {/*        )}*/}
                    {/*    />*/}
                    {/*</Col>*/}
                    <Col xs={24} sm={12} lg={8}>
                        <MetaDataCard
                            icon={<Document />}
                            title={t("service_result")}
                            text={item?.serviceResult}
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={8}>
                        <MetaDataCard
                            icon={<User />}
                            title={t("applicant_category")}
                            text={t(item?.subjectType)}
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={8}>
                        <MetaDataCard
                            icon={<MoneyBagCoin />}
                            title={t("service_price")}
                            text={t(item?.paymentType)}
                        />
                    </Col>
                </Row>

                <Spacer size={32} />

                <Row gutter={[24]}>
                    <Col xs={24} sm={12} lg={16}>
                        <Collapse size="large" items={items} bordered={false} />
                    </Col>

                    <Col xs={24} sm={12} lg={8}>
                        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
                            <MetaDataCard
                                icon={<Bank />}
                                title={t("authorized_body")}
                                text={item?.organization?.name[i18n.language]}
                                background="grey"
                            />
                            <Space size={16} />
                            <MetaDataCard
                                icon={<Clock />}
                                title={t("result_validity_period")}
                                text={
                                <>
                                  <div>
                                      {`${item?.validityPeriod?.value} ${t(item?.validityPeriod?.type)}`}
                                  </div>
                                    <p>
                                        {t('description')}:
                                        <br/>
                                        {item?.validityPeriod?.description}
                                    </p>
                                </>
                                }
                                background="grey"
                            />
                            {item?.serviceType && (
                                <MetaDataCard
                                    icon={<Document />}
                                    title={t("service_type")}
                                    text={t(item?.serviceType)}
                                    background="grey"
                                />
                            )}
                            <MetaDataCard
                                icon={<Document />}
                                title={t("service_step_and_field")}
                                text={
                                    <>
                                        <p>{t("step")}: {item?.serviceSteps?.length} ta</p>
                                        <p>{t("field")}: {item?.documentTypeIds?.length} ta</p>
                                    </>
                                }
                                background="grey"
                            />
                            {item?.documentTypeIds?.length > 0 && (
                                <MetaDataCard
                                    icon={<Document />}
                                    title={t("document_types")}
                                    text={
                                        <>
                                            <ol style={{ paddingLeft: "20px" }}>
                                                {item?.documentTypeIds?.map((docType) => (
                                                    <li key={docType?.id}>{docType.name[i18n.language]}</li>
                                                ))}
                                            </ol>
                                            {item?.documentTypeDescription &&
                                                (
                                                    <div>
                                                        <p>{t("field_document_type_description")}</p>
                                                        <h4>{item?.documentTypeDescription}</h4>
                                                    </div>
                                                )
                                            }
                                        </>
                                    }
                                    background="grey"
                                />
                            )}
                        </Space>
                    </Col>
                </Row>

                {item?.serviceType == "COMPOSITE" && item?.compositeServices?.length > 0 && (
                    <>
                        <Spacer size={40} />
                        <h2 className={cls.titleSecondary}>{t("composite_services")}</h2>
                        <Spacer size={24} />
                        <Row gutter={[16, 16]}>
                            {item?.compositeServices?.map((service, index) => (
                                <Col xs={24} sm={12} lg={6} key={index}>
                                    <div style={{ padding: "16px", background: "#fff", borderRadius: "16px", boxShadow: "0 4px 16px rgba(4, 22, 116, 0.06)" }}>
                                        <p className={cls.cardTitle} title={service.name[i18n.language]}>
                                            {service.name[i18n.language]}
                                        </p>
                                        <Link to={`/service-register/view/${service.id}`} style={{ display: "flex", alignItems: "center", gap: "12px", color: "#000C7499" }}>
                                            <span style={{ fontSize: "16px" }}>{t("details")}</span>
                                            <ArrowRight />
                                        </Link>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </>
                )}

                {item?.services?.length > 0 && (
                    <>
                        <Spacer size={40} />
                        <h2 className={cls.titleSecondary}>{t("related_state_services")}</h2>
                        <Spacer size={24} />
                        <Row gutter={[16, 16]}>
                            {item?.services?.map((service, index) => (
                                <Col xs={24} sm={12} lg={6} key={index}>
                                    <div style={{ padding: "16px", background: "#fff", borderRadius: "16px", boxShadow: "0 4px 16px rgba(4, 22, 116, 0.06)" }}>
                                        <p className={cls.cardTitle}>{service.name[i18n.language]}</p>
                                        <Link to={`/service-register/view/${service.id}`} style={{ display: "flex", alignItems: "center", gap: "12px", color: "#000C7499" }}>
                                            <span style={{ fontSize: "16px" }}>{t("details")}</span>
                                            <ArrowRight />
                                        </Link>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </>
                )}
            </div>
        </Container>

    );
};

export default ServiceView;
